import { LoadablePaint, LoadableAfterPaint } from '@confluence/loadable';
// eslint-disable-next-line no-restricted-imports
import type { LoadableType } from '@confluence/loadable/src/types.ts';

import type { TeamCalendarMacroProps } from './TeamCalendarMacro.tsx';

export const TeamCalendarMacroLoader: LoadableType<TeamCalendarMacroProps> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-TeamCalendarMacro" */ './TeamCalendarMacro.tsx'))
			.TeamCalendarMacro,
});

export const LazyTeamCalendarMacroLoader: LoadableType<TeamCalendarMacroProps> = LoadableAfterPaint(
	{
		loader: async () =>
			(await import(/* webpackChunkName: "loadable-TeamCalendarMacro" */ './TeamCalendarMacro.tsx'))
				.TeamCalendarMacro,
	},
);
